import { useState, useEffect } from 'react';
import { getFlipgiveToken } from 'common/api/crm/affiliates/service';

export const useGetFlipgiveToken = (): { token: string, isLoading: boolean} => {
    const [token, setToken] = useState('');
    const [isLoading, setIsLoading] = useState<boolean>(true);
    useEffect(() => {
        getFlipgiveToken()
            .then((result) => {
                if (result.data?.token) {
                    setToken(result.data.token);
                }
            })
            .catch((_) => {})
            .finally(() => setIsLoading(false));
    }, []);
    return {token, isLoading};
}

export const useConfigureUrlWithAffiliateToken = (
    pattern: string,
    url?: string,
    queryParams?: string
): [string, boolean] => {
    const { token, isLoading } = useGetFlipgiveToken();

    const activationUrl = token && url ? `${url?.replace(pattern, token)}${queryParams ?? ''}` : '';
    return [activationUrl, isLoading];
};
